<template>
  <div class="app-side-bar">
    <b-navbar-nav class=" d-none d-lg-block">
      <b-nav-item
        v-for="(item, idx) in items.oneItems"
        v-bind:key="'one' + idx"
        @click="$router.push(`${item.router}`)"
        class="nav-item-style"
      >
        <div class="nav-bar-item-image-container ml-4">
          <img :src="item.img" :alt="item.title" />
        </div>
        <span class="text-light">
          {{ item.title }}
        </span>
      </b-nav-item>
      <hr class="mx-4 my-3" />
      <b-nav-item
        v-for="(item, idx) in items.twoItems"
        v-bind:key="'two' + idx"
        @click="$router.push(`${item.router}`)"
        class="nav-item-style"
      >
        <div class="nav-bar-item-image-container ml-4">
          <img :src="item.img" :alt="item.img" />
        </div>
        <span class="text-light">
          {{ item.title }}
        </span>
      </b-nav-item>
    </b-navbar-nav>
  </div>
</template>
<script>
import { getIcon } from '@/utils/getIcon.js';

export default {
  computed: {
    items() {
      return {
        oneItems: [
          {
            title: 'Home',
            img: getIcon('Home'),
            router: '/',
          },
          {
            title: 'Child Challenge',
            img: getIcon('ChildChallenge'),
            router: '/challenge-select-child?next=challenge-parent-approve',
          },
          {
            title: 'Rewards',
            img: getIcon('Rewards'),
            router: '/rewards',
          },
          {
            title: 'Parent Goals',
            img: getIcon('GoalsParents'),
            router: '/parent-goals',
          },
          {
            title: 'Skill Visuals and Videos',
            img: getIcon('SkillVisual'),
            router: '/plan-select-skill?type=learn',
          },
          {
            title: 'Surveys',
            img: getIcon('Surveys'),
            router: '/surveys',
          },
          {
            title: 'Progress',
            img: getIcon('Progress'),
            router: '/progress',
          },
          {
            title: 'Badges',
            img: getIcon('Badges'),
            router: '/badges',
          },
          {
            title: 'Parenting Solutions',
            img: getIcon('ProblemSolving'),
            router: '/help-main',
          },
        ],
        twoItems: [
          {
            title: 'FAQ',
            img: getIcon('FAQ'),
            router: '/faq',
          },
          {
            title: 'Settings',
            img: getIcon('Settings'),
            router: '/settings',
          },
          {
            title: 'Log out',
            img: getIcon('LogOut'),
            router: '/logout',
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss">
.nav-item {
  a:hover {
    background: linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
  }
}

.nav-item-style {
  & > a {
    display: flex;
    gap: 1rem;
  }
}

.nav-bar-item-image-container {
  height: 35px;
  aspect-ratio: 1;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.app-side-bar {
  min-width: 25vw;
  width: 25vw;
  max-width: 25vw;
  box-shadow: 4px 2px 4px #00000026;
  z-index: 1030;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.app-side-bar::-webkit-scrollbar {
  display: none;
}
</style>
